export default __webpack_public_path__ + "static/media/quickAccessMenuBg.636202a8.png";